import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ThemeProvider } from './lib/theme';
import { SiteProvider } from './lib/site-context';
import { AuthProvider } from './lib/auth-context';
import { ScrollToTop } from './components/ScrollToTop';
import { BackToTop } from './components/BackToTop';
import App from './App';
import './styles/global.scss';
import './styles/global-admin.scss';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Elemento raiz "root" não encontrado no DOM.');
}

createRoot(rootElement).render(
  <StrictMode>
    <ErrorBoundary scope="Aplicação">
      <BrowserRouter>
        <ThemeProvider>
          <SiteProvider>
            <AuthProvider>
              <ScrollToTop />
              <App />
              <BackToTop />
            </AuthProvider>
          </SiteProvider>
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
